import {generateRequest} from 'fallco-frontend-framework/src/js/classes/HttpManager/api_utilities.js';

const END_POINT = 'storico_preventivi';

const getAllPreventivi = (settings, params, callback) => generateRequest(END_POINT, settings, {action: "get_all_preventivi", data:params}, callback);
const downloadPdf = (settings, params, callback) => generateRequest('preventivi/stampa_preventivo', settings, {action: "print_by_id" , data: params}, callback);
const deletePdf = (settings, params, callback) => generateRequest('preventivi', settings, {action: "delete_by_id" , data: params}, callback);

const apiEndpoint = {
  getAllPreventivi,
  downloadPdf,
  deletePdf
}

export default apiEndpoint;